import _classCallCheck from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";

var Events = /*#__PURE__*/function () {
  function Events(eventType) {
    var eventFunctions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, Events);

    this._eventType = eventType;
    this._eventFunctions = eventFunctions;
  }

  _createClass(Events, [{
    key: "init",
    value: function init() {
      var _this = this;

      this._eventFunctions.forEach(function (eventFunction) {
        window.addEventListener(_this._eventType, eventFunction);
      });
    }
  }]);

  return Events;
}();

export default Events;